export default __webpack_public_path__ + "left-arrow.png";